import { Injectable } from '@angular/core';
import { toPositiveNumber } from './toPositiveNumber';
import { toRgb } from '../core/color-tranformation';
var LyShadowService = (function () {
    function LyShadowService() {
    }
    /**
     * @param {?} color
     * @param {?} size
     * @return {?}
     */
    LyShadowService.prototype.shadow = function (color, size) {
        var /** @type {?} */ sizeOrigin = size;
        var /** @type {?} */ _color = toRgb(color);
        size = toPositiveNumber(size);
        var /** @type {?} */ style = "\n    rgba(" + _color.json.r + ", " + _color.json.g + ", " + _color.json.b + ", " + ((70 / 100) * Number(size / 2)) + ") 0px " + (((3 * size) - 2) / 2.5) * toPositiveNumber(sizeOrigin, true) + "px " + (3 * size * 2) / 2 + "px 0px" + ',' + " rgba(" + _color.json.r + ", " + _color.json.g + ", " + _color.json.b + ", " + ((60 / 100) * Number('0.' + String(size))) + ") 0px " + (((3 * size) - 2) / 3) * toPositiveNumber(sizeOrigin, true) + "px " + (3 * size * 2) + "px 0px" + ',' + " rgba(" + _color.json.r + ", " + _color.json.g + ", " + _color.json.b + ", " + (40 / 100) * Number('0.' + String(size)) + ") 0px " + (((3 * size) - 2)) * toPositiveNumber(sizeOrigin, true) + "px " + (3 * size * 2) / 1.4 + "px 0px";
        if (size < 2 && size > 0) {
            style = style + (", " + toRgb(color, .23).color + " 0px " + 2 * toPositiveNumber(sizeOrigin, true) + "px 6px 0px");
        }
        return style;
    };
    return LyShadowService;
}());
export { LyShadowService };
LyShadowService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
LyShadowService.ctorParameters = function () { return []; };
function LyShadowService_tsickle_Closure_declarations() {
    /** @type {?} */
    LyShadowService.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyShadowService.ctorParameters;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/shadow/shadow.service.js
// module id = 268
// module chunks = 31